// Claim tokens for anonymously-created resources.
//
// When a link or file is created without an account, the API returns a one-time
// claim token. We stash it locally so that if the same person later signs in on
// this browser they can prove ownership and claim the resource. Without the
// token the backend refuses the claim (prevents anyone from grabbing an
// unowned resource).

const PREFIX = 'linker_claim_';

function key(kind, id) {
  return `${PREFIX}${kind}_${id}`;
}

export function saveClaimToken(kind, id, token) {
  if (!token || !id) return;
  try {
    localStorage.setItem(key(kind, id), token);
  } catch (e) {
    // localStorage may be unavailable (private mode); claiming just won't work.
  }
}

export function getClaimToken(kind, id) {
  try {
    return localStorage.getItem(key(kind, id));
  } catch (e) {
    return null;
  }
}

export function clearClaimToken(kind, id) {
  try {
    localStorage.removeItem(key(kind, id));
  } catch (e) {
    // ignore
  }
}
